import { render, staticRenderFns } from "./DownloadDocumentArchive.vue?vue&type=template&id=5d57a8da&scoped=true"
import script from "./DownloadDocumentArchive.vue?vue&type=script&lang=js"
export * from "./DownloadDocumentArchive.vue?vue&type=script&lang=js"
import style0 from "./DownloadDocumentArchive.vue?vue&type=style&index=0&id=5d57a8da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d57a8da",
  null
  
)

export default component.exports